/**
 * Created by razial on 15.04.2026.
 */

const RewardedPromoTask = function (promotion, config) {
    this.promotion = promotion;
    this.config = config;

    this.onUpdate = function () {};
    this.onRewardReceived = function () {};
};

RewardedPromoTask.prototype.isCompleted = function () {
    const bit = 1 << this.config.bit;
    return !!((this.promotion.completed | this.promotion.claimed) & bit);
};

RewardedPromoTask.prototype.isClaimed = function () {
    return !!(this.promotion.claimed & (1 << this.config.bit));
};

RewardedPromoTask.prototype.getTitle = function () {
    return Messages.get(this.config.title.text, this.config.title.toReplace);
};

RewardedPromoTask.prototype.getRewards = function () {
    const category = RewardedPromoSource.findCategory(this.promotion.expectedReward);
    const cell = RewardedPromoSource.rewards[this.config.bit];
    const rewards = cell[category] || cell.none;
    return typeof UnitsLibraryHelper !== "undefined" ? UnitsLibraryHelper.ResolveRewardUnits(rewards) : rewards;
};
